<template>
  <div class="container">
    <div class="charts">
      <div ref="barChart" class="chart"></div>
      <div ref="pieChart" class="chart"></div>
      <div ref="lineChart" class="chart"></div>
    </div>
    <div class="table-container">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="park" label="园区" width="180"></el-table-column>
        <el-table-column prop="hardware" label="硬件故障" width="180"></el-table-column>
        <el-table-column prop="software" label="软件问题" width="180"></el-table-column>
        <el-table-column prop="network" label="网络问题" width="180"></el-table-column>
        <el-table-column prop="other" label="其他" width="180"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { Table, TableColumn } from 'element-ui';

export default {
  name: 'BorderSta',
  components: {
    'el-table': Table,
    'el-table-column': TableColumn
  },
  data() {
    return {
      tableData: [
        { park: '深圳园区', hardware: 100, software: 50, network: 30, other: 20 },
        { park: '北京园区', hardware: 150, software: 70, network: 40, other: 30 },
        { park: '上海园区', hardware: 80, software: 60, network: 20, other: 10 },
        { park: '广州园区', hardware: 60, software: 40, network: 10, other: 10 },
        { park: '成都园区', hardware: 40, software: 30, network: 5, other: 5 }
      ]
    };
  },
  mounted() {
    this.initBarChart();
    this.initPieChart();
    this.initLineChart();
  },
  methods: {
    initBarChart() {
      const barChart = echarts.init(this.$refs.barChart);
      const option = {
        title: {
          //text: '不同园区的工单数量',
          left: 'center'
        },
        tooltip: {},
        legend: {
          data: ['工单数量']
        },
        xAxis: {
          data: ["深圳园区", "北京园区", "上海园区", "广州园区", "成都园区"]
        },
        yAxis: {},
        series: [{
          name: '工单数量',
          type: 'bar',
          data: [120, 200, 150, 80, 70]
        }]
      };
      barChart.setOption(option);
    },
    initPieChart() {
      const pieChart = echarts.init(this.$refs.pieChart);
      const option = {
        title: {
          text: '不同类型的工单数量占比',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '工单类型',
            type: 'pie',
            radius: '50%',
            data: [
              {value: 300, name: '硬件故障'},
              {value: 250, name: '软件问题'},
              {value: 150, name: '网络问题'},
              {value: 100, name: '其他'}
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      pieChart.setOption(option);
    },
    initLineChart() {
      const lineChart = echarts.init(this.$refs.lineChart);
      const option = {
        title: {
          text: '不同园区的工单数量趋势',
          left: 'center',
          top: 20 // 调整标题的顶部位置
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['深圳园区', '北京园区', '上海园区', '广州园区', '成都园区'],
          top: 60 // 调整图例的顶部位置
        },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '深圳园区',
            type: 'line',
            data: [120, 132, 101, 134, 90, 230, 210, 150, 180, 200, 190, 220]
          },
          {
            name: '北京园区',
            type: 'line',
            data: [220, 182, 191, 234, 290, 330, 310, 250, 280, 300, 290, 320]
          },
          {
            name: '上海园区',
            type: 'line',
            data: [150, 232, 201, 154, 190, 330, 410, 350, 380, 400, 390, 420]
          },
          {
            name: '广州园区',
            type: 'line',
            data: [80, 132, 101, 134, 90, 230, 210, 150, 180, 200, 190, 220]
          },
          {
            name: '成都园区',
            type: 'line',
            data: [70, 182, 191, 234, 290, 330, 310, 250, 280, 300, 290, 320]
          }
        ]
      };
      lineChart.setOption(option);
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
}

.charts {
  flex: 1;
}

.chart {
  width: 600px;
  height: 400px;
  margin-bottom: 20px;
}

.table-container {
  flex: 1;
  padding-left: 20px;
}
</style>